import React from 'react';
import Modal from '@material-ui/core/Modal';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { API_ROOT } from 'Api/Routes';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import SubHeaderTicketDetail from '../TicketSubHeader';
import { Redirect } from 'react-router-dom';
import API from '../../../../../../api';
import AddDialog from '../AcceptNewCriteriaDialog';
import DialogActions from '@material-ui/core/DialogActions';

const Notes = styled.div`
  word-break: break-all;
  font-size: 12px;
`;
const NoteNumb = styled.span`
  color: black;
  font-weight: bold;
`;
const Note = styled.p`
  display: block !important;
`;

function getModalStyle() {
  const top = 50;
  const left = 50;
  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const styles = theme => ({
  paper: {
    position: 'absolute',
    // width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    // padding: theme.spacing.unit * 4,
    outline: 'none',
  },
  modalStyle1: {
    position: 'absolute',
    top: '10%',
    left: '10%',
    overflowX: 'hidden',
    overflowY: 'auto !important',
    height: '90%',
    display: 'block',
  },
});

class TicketModal extends React.Component {
  state = {
    redirectToCreatePage: false,
    addDialog: false,
  };
  openAddDialog = () => {
    API.checkCriteriaIfExists(this.props.ticket.ticketId)
      .then(res => {
        if (res) {
          if (res.data) {
            this.setState({ addDialog: true });
          } else {
            this.closeAddDialog();
            this.props.handleCloseModal();
            this.props.history.push({
              pathname: `/demand/project/${this.props.projectId}/ticket/create`,
              state: {
                projectId: this.props.projectId,
                ticketId: this.props.viewThisTicket.ticketId,
                isReuse: true,
              },
            });
          }
        }
      })
      .catch(error => {
        this.setState(
          state => ({
            error,
          }),
          () => {
            this.closeAddDialog();
          }
        );
      });
  };
  closeAddDialog = () => {
    this.setState({ addDialog: false });
  };

  separateNotes = note => {
    const checkIfCanDecode = item => {
      try {
        const decode = decodeURI(item);
        return decode;
      } catch (err) {
        return item;
      }
    };
    if (note) {
      // const sanitizer = dompurify.sanitize;
      // let noteSanitizer = sanitizer(note);
      let noteSanitizer = note;
      let split = noteSanitizer.split('_$_');
      return split.map((el, index) => (
        <Note key={index}>
          <NoteNumb>{index + 1 + '. '}</NoteNumb> {checkIfCanDecode(el)}
        </Note>
      ));
    }
  };

  setNameValueAndUnit = (id, name, value, unit) => {
    if (
      id === 132 ||
      id === 389 ||
      id === 270 ||
      id === 318 ||
      id === 319 ||
      id === 320 ||
      id === 321 ||
      id === 322 ||
      id === 323 ||
      id === 324 ||
      id === 325 ||
      id === 391 ||
      // id === 326 ||
      // id === 327 ||
      // id === 328 ||
      // id === 329 ||
      id === 330 ||
      id === 1304 ||
      id === 261
    ) {
      if (unit === null) {
        return value;
      } else {
        return value + ' ' + unit;
      }
    } else {
      if (value === null) {
        if (unit === null) {
          return name;
        } else {
          return name + ' ' + unit;
        }
      } else if (unit === null) {
        if (id === 331) {
          return value;
        }
        return name + ' ' + value + ' ';
      } else {
        if (id === 63 || id === 111) {
          return name + ': ' + value + unit;
        } else if (id === 376) {
          return value + unit;
        } else if (id === 568) {
          return name + value + unit;
        }
        return name + ': ' + value + unit + ' ';
      }
    }
  };

  checkForNewCriteria = (projectId, ticketId, isReuse) => event => {
    // this.setState({ redirectToCreatePage: true });
    API.setNewCustomCriteriaToMyDefault(this.props.ticket.ticketId)
      .then(res => {
        this.closeAddDialog();
        this.props.handleCloseModal();
        this.props.history.push({
          pathname: `/demand/project/${this.props.projectId}/ticket/create`,
          state: {
            projectId: this.props.projectId,
            ticketId: this.props.viewThisTicket.ticketId,
            isReuse: true,
          },
        });
      })
      .catch(error => {
        this.setState(
          state => ({
            error,
          }),
          () => {
            this.closeAddDialog();
          }
        );
      });
  };

  renderCriteriaValues = () => {
    if (
      this.props.viewThisTicket &&
      Object.keys(this.props.viewThisTicket).length > 0
    ) {
      let filteredCriteria = this.props.viewThisTicket.criteriaValues
        .map(({ criteria, ...restOfObject }) => {
          if (criteria === undefined) {
            return false;
          }
          return {
            criteria: criteria
              .map(({ criteria, ...restOfObject }) => {
                return {
                  criteria:
                    criteria && criteria.length
                      ? criteria.filter(
                          tertiaryCriteria => tertiaryCriteria.checked
                        )
                      : [],
                  ...restOfObject,
                };
              })
              .filter(({ criteria }) => criteria.length !== 0),
            ...restOfObject,
          };
        })
        .filter(({ criteria }) => {
          if (criteria === undefined) {
            return false;
          }
          return criteria.length !== 0;
        });

      return (
        <Grid container spacing={0}>
          <Grid
            item
            // lg={4}
            xs={12}
            className="ticket-details"
          >
            {/* <Grid container spacing={0}>
                  <Grid item md={6} xs={12}>
                    <Grid container spacing={0}>
                      <Grid
                        item
                        // lg={4}
                        // md={3}
                        xs={4}
                        className="ticket-details "
                      >
                        <div className="t-primary-12 t-weight-b u-mrg-bot-20">
                          Ticket reference:
                        </div>
                      </Grid>
                      <Grid
                        item
                        // lg={4}
                        // md={3}
                        xs={8}
                        className="ticket-details pad-l-8"
                      >
                        <div className="t-primary-14 c-gray-light">
                          {this.props.viewThisTicket.referenceName}
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid> */}

            <Grid container spacing={0}>
              {filteredCriteria.map(primaryCriteria => (
                <Grid container spacing={0} key={primaryCriteria.id}>
                  <Grid
                    item
                    // lg={4}
                    // md={6}
                    xs={12}
                    className="ticket-details "
                  >
                    <h2 className="t-primary-16 t-weight-b u-mrg-bot-10 u-mrg-top-10 ">
                      {primaryCriteria.name}
                    </h2>
                  </Grid>
                  <Grid container spacing={0} className="test">
                    {primaryCriteria.criteria.map(secondaryCriteria => (
                      <Grid
                        item
                        // lg={4}
                        md={6}
                        xs={12}
                        className="ticket-details u-mrg-bot-3 checklist-criteria-element-wrapper2 "
                        key={secondaryCriteria.id}
                      >
                        <div className="pad-10-criteria ">
                          <Grid
                            container
                            spacing={0}
                            key={secondaryCriteria.id}
                            className="checklist-criteria-element pad-8-y "
                          >
                            <Grid
                              item
                              // lg={4}
                              // md={6}
                              xs={4}
                              className="ticket-details "
                            >
                              <div className="t-primary-12 t-weight-b ">
                                {secondaryCriteria.name}:
                              </div>
                            </Grid>
                            <Grid
                              item
                              // lg={4}
                              // md={6}
                              xs={8}
                              className="ticket-details u-mrg-bot-3  vertical-align-text"
                            >
                              <div className="t-primary-14 c-gray-light criteria-description">
                                {secondaryCriteria.criteria.map(
                                  tertiaryCriteria => (
                                    <span key={tertiaryCriteria.id}>
                                      {this.setNameValueAndUnit(
                                        tertiaryCriteria.id,
                                        tertiaryCriteria.name,
                                        tertiaryCriteria.value,
                                        tertiaryCriteria.unit
                                      )}
                                    </span>
                                  )
                                )}
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              ))}
            </Grid>

            <div className="spacer-2 spacer-ticket" />
            <Grid container spacing={16}>
              {this.props.viewThisTicket.assets && (
                <Grid
                  item
                  // lg={4}
                  md={6}
                  xs={12}
                  className="ticket-details"
                >
                  <h2 className="t-primary-16 t-weight-b u-mrg-bot-3 u-mrg-top-10">
                    Photos
                  </h2>
                  <Grid container spacing={16}>
                    {this.props.viewThisTicket.assets
                      ? this.props.viewThisTicket.assets.map((asset, index) => (
                          <Grid
                            item
                            // lg={4}
                            md={6}
                            xs={12}
                            className="ticket-details"
                            key={index}
                          >
                            <img
                              className="imagesRadius"
                              src={API_ROOT + '/asset/' + asset}
                              alt=""
                            />
                          </Grid>
                        ))
                      : null}
                  </Grid>
                </Grid>
              )}

              {this.props.viewThisTicket.note && (
                <Grid
                  item
                  // lg={4}
                  md={6}
                  xs={12}
                  className="ticket-details"
                >
                  <h2 className="t-primary-16 t-weight-b u-mrg-bot-3 u-mrg-top-20">
                    Notes
                  </h2>
                  <Grid container spacing={0}>
                    <Grid
                      item
                      // lg={4}
                      // md={6}
                      xs={12}
                      className="ticket-details t-primary-14 c-gray-light lh-16"
                    >
                      <Notes id={'allNotes'} className="u-mrg-bot-5">
                        {this.separateNotes(this.props.viewThisTicket.note)}
                      </Notes>
                    </Grid>
                  </Grid>
                </Grid>
              )}
              <Grid item>
                {this.props.viewThisTicket.circularEconomyGroups && (
                  <h2 className="t-primary-16 t-weight-b u-mrg-bot-3 u-mrg-top-20">
                    Circular Economy Assessment
                  </h2>
                )}
                {this.props.viewThisTicket.circularEconomyGroups &&
                  this.props.viewThisTicket.circularEconomyGroups.map(item => (
                    <Grid item>
                      <Grid
                        item
                        className="t-primary-15 t-weight-b u-mrg-bot-3 u-mrg-top-20"
                      >
                        <em>{item.text}</em>
                      </Grid>
                      <Grid item>
                        {item.questions.map(question => (
                          <Grid
                            item
                            className="t-primary-13 t-weight-b u-mrg-bot-3 u-mrg-top-20 w60"
                          >
                            {question.text}
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                  ))}
              </Grid>
              <Grid item xs={12} className="u-mrg-top-20">
                {/* <Grid container spacing={32} justify="center">
                  <Grid item md={4} style={{ textAlign: 'center' }}> */}
                <DialogActions>
                  <Button
                    fullWidth
                    classes={{
                      root: 't-primary-16 c-blue-2-light t-weight-b',
                    }}
                    onClick={e => {
                      this.props.handleCloseModal();
                    }}
                  >
                    Cancel
                  </Button>
                  {/* </Grid>
                  <Grid item md={4} style={{ textAlign: 'center' }}> */}
                  <Button
                    fullWidth
                    // className="t-primary-16 btn-white"
                    classes={{
                      root: 't-primary-16 c-s-blue',
                    }}
                    variant="contained"
                    color="primary"
                    // onClick={this.checkForNewCriteria(
                    //   this.props.viewThisTicket.projectId,
                    //   this.props.viewThisTicket.ticketId,
                    //   true
                    // )}
                    onClick={this.openAddDialog}
                  >
                    Reuse
                  </Button>
                </DialogActions>
                {/* </Grid>
                </Grid> */}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      );
    }
  };

  render() {
    const { classes } = this.props;
    if (!this.props.viewThisTicket) return;
    return (
      <React.Fragment>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.props.openModal}
          onClose={this.props.handleCloseModal}
        >
          <div
            style={getModalStyle()}
            className={this.props.classes.modalStyle1 + ' ' + classes.paper}
          >
            <SubHeaderTicketDetail
              ticket={
                this.props.viewThisTicket ? this.props.viewThisTicket : null
              }
            />
            <div className="seal-deal-fav__main">
              {this.renderCriteriaValues()}
            </div>
          </div>
        </Modal>
        <AddDialog
          doAdd={this.checkForNewCriteria()}
          handleClose={this.closeAddDialog}
          isOpen={this.state.addDialog}
        />
      </React.Fragment>
    );
  }
}

TicketModal.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TicketModal);
